import React from 'react';

interface SearchBoxProps {
  handleSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholderText?: string;
  value: string;
}

const DEFAULT_PLACEHOLDER_TEXT = 'Search the table';

const SearchBox = ({ handleSearch, placeholderText, value }: SearchBoxProps) => {
  return (
    <div className="mr-auto w-[1040px] max-w-full">
      <input
        value={value ?? ''}
        onChange={handleSearch}
        type="text"
        name="table-search"
        id="datatable-search-box"
        className=" w-full max-w-full rounded-2 border border-solid border-grayscale-beige bg-white px-16 py-12 text-caption-md outline-0 placeholder:italic placeholder:text-grayscale-gray md:max-w-sm"
        placeholder={placeholderText || DEFAULT_PLACEHOLDER_TEXT}
      ></input>
    </div>
  );
};

export default SearchBox;
